import Crud from '../views/Produto/Crud'
import Entity from '../views/Produto/Add'

let routes = {
    path: '/produtos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/produtos/add',
            name: 'NewProduto',
            component: Entity
        },
        {
            path: '/produtos/edit/:id?',
            name: 'EditProduto',
            component: Entity
        },
        {
            path: '/produtos',
            name: 'list-produtos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Produtos',
                breadcrumb: [
                    {
                        text: 'Produtos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
